import { SignOut, WarningCircle } from '@phosphor-icons/react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { SubscriptionTab } from '@/components/settings/SubscriptionTab';
import { useLogout } from '@/hooks/useLogout';

/**
 * The whole office app while a company that came in on a free trial has not
 * paid since it ended (`isLockedAfterPlatformTrial`). Only the plan is left:
 * an admin pays for the selected interval ("Pay to unlock"), the organization query
 * refetches, and the app comes back. Anyone else is told to ask an admin, and
 * everyone can log out — there is no sidebar or profile menu here.
 */
export function TrialEndedGate() {
  const logout = useLogout();
  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto w-full max-w-3xl space-y-5 px-4 py-10">
        <Alert variant="warning">
          <WarningCircle className="h-4 w-4" />
          <AlertTitle>Your free trial has ended</AlertTitle>
          <AlertDescription>
            Choose your billing schedule and pay below to pick up
            right where you left off — your customers, crews and schedule are all still here.
          </AlertDescription>
        </Alert>
        <SubscriptionTab />
        <div className="flex justify-end">
          <Button variant="ghost" onClick={logout}>
            <SignOut className="mr-2 h-4 w-4" />
            Log out
          </Button>
        </div>
      </div>
    </div>
  );
}
